<template>
    <div class="alert alert-light" v-if="doc">
      <span class="close" v-if="doc.doc_certificado && doc.doc_certificado_link">
        <a href="#" class="alert-link mr-1 ml-2" @click.prevent="cancelar(doc)">
          <i class="fa fa-times-circle" aria-hidden="true"></i>
        </a>
      </span>
      <span class="close" v-if="doc.doc_certificado && doc.doc_certificado_link">
        <a :href="doc.doc_certificado_link" class="alert-link mr-1 ml-2" target="_blank">
          <i class="fas fa-file-contract"></i>
        </a>
      </span>
      <span class="close" v-else-if="pode_assinar">
        <a href="#" class="alert-link mr-1 ml-2" @click.prevent="assinar()">
          <i class="fas fa-signature"></i>
        </a>
      </span>
      <span class="close" v-if="!view">
        <a href="#" @click.prevent="imprimir_documento()" class="alert-link" title="Imprimir">
          <i class="fas fa-print"></i>
        </a>
      </span>
      <span class="close" v-if="!view">
        <a class="alert-link mx-2" href="#" @click.prevent="editar()" title="Editar">
          <i class="far fa-file-alt"></i>
        </a>
      </span>
      <span class="close text-danger small" v-if="doc.removendo">
        <div class="spinner-border spinner-border-sm" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </span>
      <div>
        <div class="mb-3">{{ doc.st_titulo }}</div>
        <div v-if="doc.fl_formulario">
          <formulario v-model="doc.estrutura" mode="view" />
        </div>
        <div v-else v-html="doc.texto_html"></div>
      </div>
    </div>
</template>

<script>
import Formulario from "./Formulario.vue";

export default {
    props: ['doc', 'view', 'pode_assinar'],

    components: { 
        Formulario,
    },

    methods: { 
        assinar() { 
            this.$emit('assinar');
        },

        imprimir_documento() { 
            this.$emit('imprimir_documento');
        },

        editar() { 
            this.$emit('editar');
        }
    }
}
</script>